
import { locale } from './globals.js';
import { getOffset } from './toolbox.js';

class Filter {
  constructor (el) {
    if(!el) return false;
    this.el = el;
    this.id = this.el.getAttribute('data-filter');
    this.initList();
    this.initSearch();
  }
  initList () {
    this.domLists = Array.from(document.querySelectorAll(`[data-filter-list=${this.id}]`));
    this.items = [];
    this.domLists.forEach( (list) => {
      list.classList.add('filter-list');
      let domItems = Array.from(list.children);
      domItems.forEach((elem) => {
        let text = elem.querySelector('[data-filter-text]')
        let tags = elem.querySelector('[data-filter-tags]');
        let content = "";
        if (text) content += text.innerText;
        if (tags) content += ` ${tags.getAttribute('data-filter-tags')}`;
        elem.classList.add('filter-list-item');
        this.items.push (
          { content, elem }
        )
      })
    });
  }
  initSearch () {
    this.el.addEventListener('submit', (event) => {event.preventDefault()});
    this.searchBox = this.el.querySelector('[data-filter-search]');
    this.searchBox.addEventListener('input', this.searchUpdate.bind(this));
    this.searchBox.addEventListener('focus', () => {
      let pos = getOffset(this.searchBox).top - 50;
      window.scroll({ top: pos, left: 0, behavior: 'smooth' });
    });
  }
  searchUpdate (event) {
    let term = this.searchBox.value.trim();
    let results = 0;
    if (term.length > 2) {
      this.items.forEach((item) => {
        let terms = term.split(' ');
        let pass = true;
        if (terms.length < 2) {
          if(item.content.toUpperCase().includes(term.toUpperCase())) {
            item.elem.classList.remove('hide');
            results++;
          } else {
            item.elem.classList.add('hide');
          }
        } else {
          terms.forEach((t) => {
            if(!item.content.toUpperCase().includes(t.toUpperCase())) {
              pass = false;
            }
          })
          if (pass) {
            item.elem.classList.remove('hide');
            results++;
          } else {
            item.elem.classList.add('hide');
          }
        }

        
      })
      if (results == 0) {
        this.domLists.forEach((list) => {
          list.classList.add('no-results')
          let msg = list.getAttribute('data-filter-no-results').split(':');
          if (msg) list.setAttribute('data-filter-no-results', `${msg[0]}: ${term}`);
        })
      } else {
        this.domLists.forEach((list) => { list.classList.remove('no-results')})
      }
    } else {
      this.domLists.forEach((list) => { list.classList.remove('no-results')})
      this.items.forEach((item) => {
        item.elem.classList.remove('hide');
      })
    }
    
  }

  
}
export default function () {
  new Filter(document.querySelector('[data-filter]'));
}
